export const ActivateTutoringJourneyParamKey = "activate-tutoring";

export enum Stage {
  Start = "start",
  YearGroup = "year-group",
  ActivationCode = "activation-code"
}
